export default __webpack_public_path__ + "static/media/L.8599a0d2.svg";